<template>
    <v-menu
    :close-on-content-click="false"
    offset-y>
      <template v-slot:activator="{ on, attrs }">

        <v-btn v-if="!user" rounded outlined text
          v-bind="attrs"
          v-on="on"
          size="35"
          :loading="loading"
        >
          <span class="mr-2">Log in</span>
        </v-btn>
      </template>
      <v-card
        class="mx-auto"
        max-width="344"
        outlined
      >
 
        <login />
      </v-card>
    </v-menu>
</template>

<script>
import {get,sync} from 'vuex-pathify'
import login from './login.vue'

  export default {
    props: {
      loading: {
        type: Boolean,
        default: true,
      }
    },
    components: {
      login,
    },

    computed: {
      user: get("user"),
    },
    methods: {
      logout() {
        this.$store.dispatch("logOut")
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>